import React from "react";
import { connect } from "react-redux";
import { Div } from "components/Base";
import SelectedItem from "./SelectedSessionItem";
import { actions, getters } from "../../model";
import { noop } from "lodash";

const decorate = connect(
  (state, props) => ({
    selectedsessionsToConvert: getters.selectedsessionsToConvert(state, props)
  }),
  {
    selectItem: actions.selectItem
  }
);

const Empty = ({ children }) => (
  <Div
    display="column.center.center"
    bg="neutral1"
    color="gray5"
    bra={1}
    fw={3}
    fs={3}
    p={3}
  >
    {children}
  </Div>
);

const Panel = ({ title, children }) => (
  <Div py={3} px={3} bra={1} bg="neutral1">
    <Div mb={2} fw={3}>
      {title}
    </Div>
    {children}
  </Div>
);

const Sidebar = ({ selectItem = noop, selectedsessionsToConvert = {} }) => (
  <Div
    height={1}
    width={272}
    px={3}
    py={3}
    bg="white"
    style={{
      overflowY: "auto"
    }}
  >
    <Panel title="Selected:">
      <Div>
        {!Object.keys(selectedsessionsToConvert).length ? (
          <Empty>No records selected</Empty>
        ) : null}
        {Object.keys(selectedsessionsToConvert).map(recordId => {
          const record = selectedsessionsToConvert[recordId];
          return (
            <SelectedItem
              key={recordId}
              name={`${record.friendly_id}: ${record.title}`}
              id={record.id}
              onClick={selectItem}
            />
          );
        })}
      </Div>
    </Panel>
  </Div>
);

export default decorate(Sidebar);
